<!-- 节庆热点 -->
<template>
  <div class="category-management">
    <page-title title="筛选">
      <el-row class="category-management__filter-header" :gutter="20">
        <el-col :xl="4" :span="6">
          <span>节庆名称：</span>
          <el-input v-model="filter.name" placeholder="请输入"></el-input>
        </el-col>
        <!-- <el-col :xl="2" :span="4">
                    <el-checkbox :active-value="1" :inactive-value="0" v-model="filter.isHomepage">只看首页推荐</el-checkbox>
                </el-col> -->
        <el-col :xl="2" :span="4">
          <el-checkbox
            :false-label="0"
            :true-label="1"
            v-model="filter.isPicture"
            >只看推荐</el-checkbox
          >
        </el-col>
        <el-col :xl="3" :span="6">
          <el-button @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
          <el-button @click="openDialog('add')">新增</el-button>
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div class="category-management__body">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ backgroundColor: `#f7f7f7` }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="100"
          ></el-table-column>
          <el-table-column prop="name" label="节庆名称"></el-table-column>
          <el-table-column prop="date" label="日期"></el-table-column>
          <el-table-column label="图片页面推荐">
            <template slot-scope="scope">
              <el-switch
                @change="handleSwitchChange(scope.row)"
                :active-value="1"
                :inactive-value="0"
                active-color="#005bff"
                inactive-color="#dadde0"
                v-model="scope.row.isPicture"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column
            prop="sort"
            label="序号"
            width="80"
          ></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <!--  -->
              <!-- {{ tableData[0].id }}
                            {{ scope.row.id }} -->
              <el-button
                class="edit"
                type="text"
                @click="openDialog('edit', scope.row)"
                >编辑</el-button
              >
              <el-button
                :disabled="scope.$index == 0"
                class="edit"
                type="text"
                @click="move('up', scope.row)"
                >上移</el-button
              >
              <el-button
                :disabled="scope.$index == tableData.length - 1"
                class="edit"
                type="text"
                @click="move('down', scope.row)"
                >下移</el-button
              >
              <el-button class="edit" type="text" @click="deleteRow(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination
          :total="total"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          @size-change="getList"
        ></cus-pagination>
      </div>
    </page-title>
    <!-- 新增 编辑 弹窗 -->
    <category-dialog
      :title="dialogMode === 'add' ? '新增节庆热点' : '编辑节庆热点'"
      :showType="1"
      :visible.sync="dialogVisible"
      :data="currentData"
      :mode="dialogMode"
      @confirm="handleConfirm"
      :loading="apiEnd"
    ></category-dialog>
  </div>
</template>

<script>
import PageTitle from "@/components/pageTitle.vue";
import CusPagination from "@/components/cusPagination.vue";
import {
  getPicturePageList,
  festiveAdd,
  festiveEdit,
  festiveUpAndDown,
  festiveDel,
} from "@/api/page";
import CategoryDialog from "./components/CategoryDialog.vue";
import { Message } from "element-ui";
import { scope } from "@/config/config";
export default {
  components: {
    PageTitle,
    CusPagination,
    CategoryDialog,
  },
  data() {
    return {
      apiEnd: false,
      loading: true,
      filter: {
        name: "",
        isPicture: null,
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogMode: "add", // 默认模式
      currentData: {}, // 当前表单数据
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
  },
  methods: {
    async getList() {
      this.loading = true;
      const params = {
        pageSize: this.pageSize,
        pageOn: this.currentPage,
        name: this.filter.name, // name field is always passed
      };

      // Only add isPicture field when value is 1
      if (this.filter.isPicture === 1) {
        params.isPicture = this.filter.isPicture;
      }

      const { data } = await this.$ajax.get(getPicturePageList, params);
      this.tableData = data?.data?.records || [];
      this.total = data?.data?.total || 0;
      this.loading = false;
    },
    search() {
      this.getList();
    },
    reset() {
      this.filter.name = "";
      this.filter.isPicture = null;
      this.getList();
    },
    edit(row) {
      console.log("Editing row", row);
    },
    async delApi(id) {
      const res = await this.$ajax.delete(festiveDel(id));
      const { code, msg } = res?.data ?? {};
      console.log(code);
      if (code == 200) {
        Message.success(msg);
        this.getList();
      }
    },
    /**
     * 删除
     */
    deleteRow(row) {
      if (row.isPicture == 1) {
        Message.warning("开启推荐的图片不允许删除");
        return;
      }
      this.$confirm("确认删除该项吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.delApi(row.id);
        })
        .catch(() => {
          Message.info("删除已取消");
        });
    },
    handlePageChange(page) {
      console.log("Page changed to", page);
    },
    openDialog(mode, data = {}) {
      this.dialogMode = mode;
      this.currentData = { ...data };
      this.dialogVisible = true;
    },
    /**
     * 新增接口
     */
    async addApi(params) {
      this.apiEnd = true;
      const { data } = await this.$ajax.post(festiveAdd, params);
      if (data.code === 200) {
        this.apiEnd = false;
        this.dialogVisible = false;
        this.getList();
        Message.success(data.msg);
      } else if (data.code === 500) {
        this.$message.error(data.msg);
        this.apiEnd = false;
      }
    },
    /**
     * 编辑接口
     */
    async editApi(params) {
      this.apiEnd = true;
      const { data } = await this.$ajax.put(festiveEdit, params);
      if (data.code === 200) {
        this.apiEnd = false;
        this.dialogVisible = false;
        this.getList();
        Message.success(data.msg);
      } else if (data.code === 500) {
        this.$message.error(data.msg);
        this.apiEnd = false;
      }
    },
    handleSwitchChange(row) {
      const { id, isPicture } = row;
      const params = {
        id,
        isPicture,
      };
      this.editApi(params);
    },
    /**
     * 上移下移
     */
    async upAndDownApi(data) {
      const { data: res } = await this.$ajax.get(festiveUpAndDown, data);
      if (res.code === 200) {
        this.getList();
      }
    },
    /**
     * 移动
     */
    move(type, row) {
      const { id } = row;
      const currentIndex = this.tableData.findIndex((item) => item.id === id);
      let targetSort;

      if (type === "up" && currentIndex > 0) {
        targetSort = this.tableData[currentIndex - 1].sort;
      } else if (type === "down" && currentIndex < this.tableData.length - 1) {
        targetSort = this.tableData[currentIndex + 1].sort;
      }

      this.upAndDownApi({ id, sort: targetSort });
    },
    handleConfirm(formData) {
      let that = this;
      if (this.dialogMode === "add") {
        that.addApi(formData);
      } else {
        console.log("编辑数据:", formData);
        that.editApi(formData);
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.category-management {
  .box-card {
    margin-bottom: 20px;
  }

  &__filter-header {
    display: flex;
    align-items: center;
  }

  &__body {
    .edit {
      color: #005bff;
    }

    .el-button.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }

    .el-switch__label {
      color: #333333;
    }

    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
  }
}
</style>
